import { render, staticRenderFns } from "./ShopMLVerificationPage.vue?vue&type=template&id=96f4522c&scoped=true&"
import script from "./ShopMLVerificationPage.vue?vue&type=script&lang=js&"
export * from "./ShopMLVerificationPage.vue?vue&type=script&lang=js&"
import style0 from "./ShopMLVerificationPage.vue?vue&type=style&index=0&id=96f4522c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f4522c",
  null
  
)

export default component.exports